import { createApiRef } from '@backstage/core-plugin-api';
import { WorkflowPhase } from './types';

// A parameter the user can set when triggering a build. `key` is the Argo
// workflow parameter name; `defaultValue` seeds the form; booleans render as
// a toggle (submitted as the string "true"/"false" that the templates expect).
export interface CiPipelineParam {
  key: string;
  label: string;
  defaultValue: string;
  type?: 'text' | 'boolean';
  description?: string;
}

// A known CI build pipeline, backed by an Argo WorkflowTemplate in the `ci`
// namespace. `template` is the WorkflowTemplate name submitted via
// workflowTemplateRef.
export interface CiPipeline {
  id: string;
  label: string;
  description: string;
  template: string;
  namespace?: string;
  params: CiPipelineParam[];
}

export interface CiRun {
  workflowName: string;
  namespace: string;
  uid: string;
  phase: WorkflowPhase;
  template: string;
  startedAt?: string;
  finishedAt?: string;
  branch?: string;
  commit?: string;
}

export interface TriggerCiOptions {
  pipeline: CiPipeline;
  parameters: Record<string, string>;
}

export interface CiPipelinesApi {
  listPipelines(): Promise<CiPipeline[]>;
  listRuns(): Promise<CiRun[]>;
  triggerBuild(opts: TriggerCiOptions): Promise<{ namespace: string; name: string }>;
}

export const ciPipelinesApiRef = createApiRef<CiPipelinesApi>({
  id: 'plugin.ci-pipelines.service',
});
